import { Pipe, PipeTransform } from '@angular/core';
import { UserRole } from '@fleet-beat/core';
import { AuthService } from '@fleet-beat/shared';

interface NavigationItem {
  id: string;
  type: 'link' | 'gap' | 'group';
  children: NavigationItem[];
}

@Pipe({
  name: 'disallowRoutesByRoles',
})
export class DisallowRoutesByRolesPipe implements PipeTransform {
  constructor(private authService: AuthService) {}
  transform(routesToFilter: NavigationItem[], rolesToDisallow?: `${UserRole}`[], routes?: string[]): NavigationItem[] {
    if (!routes || !routes.length || !rolesToDisallow || !rolesToDisallow.length) return routesToFilter;
    const canAccess: boolean = !rolesToDisallow.includes(this.authService?.authUser?.role);
    const filteredRoutes: NavigationItem[] = routesToFilter
      .filter((route: NavigationItem) => {
        const routeToDisallow: string | undefined = routes.find((id: string) => id == route.id);
        if (!routeToDisallow) return true;
        return routeToDisallow && canAccess;
      })
      .map((route: NavigationItem) => {
        if (route.children?.length) {
          return {
            ...route,
            children: route.children.filter((cRoute: NavigationItem) => {
              const routeToDisallow: string | undefined = routes.find((id: string) => id == cRoute.id);
              if (!routeToDisallow) return true;
              return routeToDisallow && canAccess;
            }),
          };
        } else {
          return route;
        }
      });
    return filteredRoutes;
  }
}
